import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginUser } from '@app/shared/models/authenticated-user.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthenticatedUserAdapter } from './authenticated-user.adapter';

@Injectable()
export class LoginService {
    private httpSkippingInterceptors: HttpClient;

    constructor(
        private httpClient: HttpClient,
        private httpBackend: HttpBackend,
        private adapter: AuthenticatedUserAdapter
    ) {
        this.httpSkippingInterceptors = new HttpClient(this.httpBackend);
    }

    login(email: string, password: string): Observable<LoginUser> {
        return this.adaptLoginUserObservable(
            this.httpSkippingInterceptors.put(ENDPOINTS.apis.login.base, { email, password })
        );
    }

    refreshToken(currentToken: string): Observable<LoginUser> {
        return this.adaptLoginUserObservable(
            this.httpClient.put(ENDPOINTS.apis.login.refreshToken, { key: currentToken })
        );
    }

    private adaptLoginUserObservable(data$: Observable<any>): Observable<LoginUser> {
        return data$.pipe(
            map((data: any) => ({
                ...this.adapter.adapt(data),
                token: data.token,
                rawValue: JSON.stringify(data),
            }))
        );
    }
}
